
import AmplifyAuth from "components/amplify-auth";

export default function AuthView(props) {
    return (
        <AmplifyAuth {...props} />
    );
}